import { useEffect, useRef } from 'react';
import { Link, useSearchParams } from 'react-router';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { api } from '../api.ts';
import { ErrorBox } from '../components/ui.tsx';

/**
 * Retorno da autorização do Mercado Livre (https://berytus.com.br/app/meli/?code=…&state=…).
 * Conclui a conexão com o usuário logado; se não estiver logado, o login traz de volta para cá.
 */
export function MeliCallback() {
  const [params] = useSearchParams();
  const qc = useQueryClient();
  const code = params.get('code');
  const state = params.get('state');
  const denied = params.get('error');
  const sent = useRef(false);

  const finish = useMutation({
    mutationFn: () => api<{ nickname: string }>('/channels/mercadolivre/callback', { method: 'POST', json: { code, state } }),
    onSuccess: () => qc.invalidateQueries({ queryKey: ['channels'] }),
  });

  useEffect(() => {
    // Uma vez só (o código do Mercado Livre é de uso único, e o modo estrito do React roda efeitos duas vezes).
    if (code && state && !sent.current) {
      sent.current = true;
      finish.mutate();
    }
  }, [code, state]); // eslint-disable-line react-hooks/exhaustive-deps

  return (
    <>
      <div className="page-head"><div><h1>Conectando o Mercado Livre</h1></div></div>
      <div className="panel" style={{ maxWidth: 640 }}>
        {denied ? (
          <p style={{ margin: 0 }}>A autorização não foi concedida no Mercado Livre. <Link to="/canais">Tentar de novo</Link>.</p>
        ) : !code || !state ? (
          <p style={{ margin: 0 }}>Este endereço não trouxe a autorização. <Link to="/canais">Voltar para Integração de canais</Link>.</p>
        ) : finish.isPending || finish.isIdle ? (
          <p style={{ margin: 0 }}>Concluindo a conexão…</p>
        ) : finish.error ? (
          <div className="stack-y" style={{ gap: 12 }}>
            <ErrorBox error={finish.error} />
            <Link className="btn" to="/canais">Voltar para Integração de canais</Link>
          </div>
        ) : (
          <div className="stack-y" style={{ gap: 12 }}>
            <p style={{ margin: 0 }}>
              Conta <b>{finish.data?.nickname}</b> conectada. A leitura dos anúncios começou; em alguns minutos eles aparecem no canal.
            </p>
            <Link className="btn primary" to="/canal/mercadolivre">Abrir o Mercado Livre</Link>
          </div>
        )}
      </div>
    </>
  );
}
